const reducer = (state: any, action: any) => ({
  ...state,
  hashedCustomerId: action.payload,
});

export default reducer;
